<template>
	<nav class="Header-list" :class="{ 'Header-list--dropdown': dropdown }" :aria-labelledby="uniqueId">
		<h2 v-if="label.length" class="Header-list-heading" :id="uniqueId" tabindex="-1">
			<CloIcon v-if="icon.length" :symbol="icon" />
			<span class="Header-list-heading-label">{{ label }}</span>
			<CloIcon v-if="dropdown" symbol="triangleDown" />
			<span class="Header-dropdown-closer" data-header-closer></span>
		</h2>
		<ul class="Header-list-list">
			<!-- @slot for the header group list-->
			<slot />
		</ul>
	</nav>
</template>

<script>
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
export default {
	name: 'CloHeaderList',
	components: { CloIcon },
	data() {
		return {
			uniqueId: 'id-' + Math.random().toString(36).substr(2, 9),
		};
	},
	props: {
		dropdown: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '',
		},
		icon: {
			type: String,
			default: '',
		},
	},
	computed: {},
};
</script>

<style lang="scss"></style>
